export const MODES = {
    DISPLAY: 'display',
    ADD: 'add',
    EDIT: 'edit',
};
